var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEyeCloseBlueIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4854",
    "data-name": "Rectangle 4854",
    width: 21.564,
    height: 15.778,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_13303",
    "data-name": "Group 13303",
    transform: "translate(-850 -994)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_569",
    "data-name": "Ellipse 569",
    transform: "translate(850 994)",
    fill: "#014fe0",
    stroke: "#fff",
    strokeWidth: 0.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16.5,
    cy: 16.5,
    r: 16.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16.5,
    cy: 16.5,
    r: 16.25,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_13219",
    "data-name": "Group 13219",
    transform: "translate(855.718 1002.11)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12189",
    "data-name": "Group 12189",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_45243",
    "data-name": "Path 45243",
    d: "M5.069,12.614c-.551-.386-1.067-.729-1.562-1.1A19.243,19.243,0,0,1,.213,8.389.7.7,0,0,1,.2,7.4a18.16,18.16,0,0,1,6.364-5,9.821,9.821,0,0,1,4.409-.957,10.107,10.107,0,0,1,4.006.956.265.265,0,0,0,.361-.067c.692-.7,1.394-1.4,2.093-2.094a.7.7,0,0,1,.738-.2.679.679,0,0,1,.493.531.745.745,0,0,1-.254.724Q16.986,2.7,15.569,4.123,9.885,9.793,4.2,15.46a1.171,1.171,0,0,1-.505.3.665.665,0,0,1-.743-.375.7.7,0,0,1,.149-.842q.877-.883,1.762-1.758c.058-.058.127-.1.209-.17M7.785,9.791l4.9-4.894a3.538,3.538,0,0,0-4.9,4.894",
    transform: "translate(-0.001 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45244",
    "data-name": "Path 45244",
    d: "M131.478,76.688c.05-.057.085-.1.125-.143.724-.724,1.448-1.449,2.177-2.168a.344.344,0,0,1,.246-.1,3.551,3.551,0,0,0,3.707-2.248,3.223,3.223,0,0,0,.221-1.667.288.288,0,0,1,.069-.215q1.6-1.606,3.2-3.2c.032-.031.064-.061.113-.108.144.105.289.206.429.314a20.055,20.055,0,0,1,3.2,3.069.7.7,0,0,1,.034.96,17.731,17.731,0,0,1-6.928,5.258,9.372,9.372,0,0,1-6.5.289c-.026-.008-.051-.02-.1-.038",
    transform: "translate(-123.61 -62.835)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeCloseBlueIcon);
export default __webpack_public_path__ + "static/media/eye_close_blue_icon.3d56788313e7cc72df6c2fc5d86fbb9d.svg";
export { ForwardRef as ReactComponent };